import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'app/core/user/user.service';

@Pipe({
  name: 'hasRole',
  standalone: true,
  pure: false
})
export class HasRolePipe implements PipeTransform {

  constructor(private userService: UserService) { }

  transform(roles: string | string[]): boolean {
    const userRoles = this.userService.getRoles();

    const requiredRoles = Array.isArray(roles) ? roles : [roles];

    return requiredRoles.some(role => userRoles.includes(role));
  }
}